var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 12.44h12m-12 0v-3l8.151-8.152.002-.001c.296-.296.444-.445.615-.5a.75.75 0 0 1 .464 0c.17.055.319.203.615.5l1.305 1.304c.297.297.445.446.5.617a.75.75 0 0 1 0 .463c-.055.171-.203.32-.5.616v.001L3.75 12.44z"
  })));
};
export default SvgPencil;